import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PAGE } from "components/common/CONSTANTS";
import { downloadMaxCapReportAction, downloadMaxCapReportReset } from "redux/actions/downloadMaxCapReportAction";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import { showErrorMessageByCode } from "services/commonServices";
import { DOWNLOAD_SUCCESFULL, FILE_DOWNLOAD_LOADING_MESSAGE, MAXCAP_SUCCESS_DOWNLOAD_EXTRACT } from "services/CONSTANTS";

export const MaxOrderQuantityDownloadReport = () => {
  const dispatch = useDispatch();
  const { isDownloadSuccess, isDownloadFail, downloadMaxCapResponse } =
    useSelector((state) => state.downloadMaxCapReport);

  const [showFileDownloadPopup, setShowFileDownloadPopup] = useState(false);

  const handleDownload = () => {
    setShowFileDownloadPopup(true);
    dispatch(downloadMaxCapReportAction());
  };

  useEffect(() => {
    if (isDownloadSuccess) {
      const { downloadUrl } = downloadMaxCapResponse?.data || {};
      const fileDownloadTag = document.createElement("a");
      fileDownloadTag.href = downloadUrl;
      fileDownloadTag.click();

      setShowFileDownloadPopup(false);
      dispatch(
        showNotificationDialogEmergencyOrder(
          DOWNLOAD_SUCCESFULL,
          MAXCAP_SUCCESS_DOWNLOAD_EXTRACT,
          "Done"
        )
      );
      dispatch(downloadMaxCapReportReset());
    }
  }, [isDownloadSuccess, downloadMaxCapResponse, dispatch]);

  useEffect(() => {
    if (isDownloadFail) {
      setShowFileDownloadPopup(false);
      if (downloadMaxCapResponse?.response?.status === 404) {
        dispatch(showNotificationDialogEmergencyOrder("Download Failed", "No records found to download.", "Done"));
      } else {
        const { errTitle, errContent } = showErrorMessageByCode(downloadMaxCapResponse);
        dispatch(showNotificationDialogEmergencyOrder(errTitle, errContent, "Done"));
      }
      dispatch(downloadMaxCapReportReset());
    }
  }, [isDownloadFail, downloadMaxCapResponse, dispatch]);

  return (
    <>
      {showFileDownloadPopup ? (
        <Dialog open={showFileDownloadPopup} maxWidth="sm" fullWidth={true}>
          <DialogTitle>File Downloading</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography sx={{ mt: 1 }} variant="subtitle2">
              {FILE_DOWNLOAD_LOADING_MESSAGE}
            </Typography>
          </DialogContent>
        </Dialog>
      ) : (
        <div></div>
      )}

      <div className="mainPageStyling">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            {PAGE.MAX_CAP_DOWNLOAD_EXTRACT.label}
          </Typography>
        </div>
        <div className="labelControl">
          <Typography style={{ fontSize: "12px", marginTop: "16px" }}>
            Please click{" "}
            <Link
              style={{
                color: "#108810",
                cursor: "pointer",
                fontSize: "12px",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
              onClick={handleDownload}
            >
              here
            </Link>{" "}
            to download the complete extract containing the{" "}
            <strong>maximum order quantity details for order pad items</strong>.
          </Typography>
        </div>
      </div>
    </>
  );
};
